/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PasswordResetAttestationData } from './PasswordResetAttestationData';
import {
    PasswordResetAttestationDataFromJSON,
    PasswordResetAttestationDataFromJSONTyped,
    PasswordResetAttestationDataToJSON,
    PasswordResetAttestationDataToJSONTyped,
} from './PasswordResetAttestationData';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface PasswordResetAttestation
 */
export interface PasswordResetAttestation {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordResetAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {PasswordResetAttestationData}
     * @memberof PasswordResetAttestation
     */
    data?: PasswordResetAttestationData;
}



/**
 * Check if a given object implements the PasswordResetAttestation interface.
 */
export function instanceOfPasswordResetAttestation(value: object): value is PasswordResetAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function PasswordResetAttestationFromJSON(json: any): PasswordResetAttestation {
    return PasswordResetAttestationFromJSONTyped(json, false);
}

export function PasswordResetAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : PasswordResetAttestationDataFromJSON(json['data']),
    };
}

export function PasswordResetAttestationToJSON(json: any): PasswordResetAttestation {
    return PasswordResetAttestationToJSONTyped(json, false);
}

export function PasswordResetAttestationToJSONTyped(value?: PasswordResetAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': PasswordResetAttestationDataToJSON(value['data']),
    };
}

